import module from 'fan/proyecto/module.js'
import template from './template.html'

function Modelo () {
  this.colaborador_id = null
  this.colaborador = ''
  this.notas = ''
  this.completado = false
  this.actualizado = false
  this.error = null
}

export class FanProyectoColaboradoresEditarEliminarComponent {
  actualizando = false
  completado = false
  data = null
  error = null
  step = 1
  resultados = undefined
  modelo = Modelo
  idProyecto
  colaboradores = []

  constructor ($state, Colaborador) {
    this.$state = $state
    this.ColaboradorService = Colaborador
  }

  $onInit () {
    this.headers = [{
      id: 'colaborador_id',
      name: 'Colaborador ID',
      group: 'REQUERIDO',
      //parser: (value) => (Number(value) || 0),
      processor: (object, value) => {
        object.colaborador_id = value

        return object
      },
      match: (value) => ['COLABORADOR_ID', 'EMPLEADO_ID', 'NOMBRE_ID'].indexOf(value.toUpperCase()) >= 0,
    }, {
      id: 'colaborador',
      name: 'Colaborador',
      group: 'REQUERIDO',
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.colaborador = value

        return object
      },
      match: (value) => ['COLABORADOR', 'EMPLEADO', 'NOMBRE'].indexOf(value.toUpperCase()) >= 0,
    }]
  }

  actualizar (data) {
    if (!data) return
    this.resultados = data
    this.resultados.map((item, indice) => item.indice = indice + 1)

    this.iniciarVerificacion()
  }

  iniciar () {
    this.resultadosModal = this.resultados.filter((item) => !item.actualizado && item.eliminable)
    this.completado = true
  }

  iniciarVerificacion () {
    this.contador = [...this.resultados]

    this.step = 0

    this.filtradoColaboradores()
  }

  filtradoColaboradores () {
    if (!this.contador.length) {
      this.resultados = this.colaboradores
      this.resultados.map((item, indice) => item.indice = indice + 1)
      this.step = 3
    }

    let colaborador = this.contador.shift()
    this.verificar(colaborador)
  }

  terminar (event) {
    console.info('terminar', event)
    this.completado = false
    if (event) {
      let error = event.some((item) => item.error)
      if (!error) this.$state.go('proyecto.colaboradores.lista')
      this.resultados.map((item) => {
        event.forEach((data) => {
          if (item.indice === data.indice) {
            item.error = data.error
            item.actualizado = data.actualizado
            item.completado = data.completado
          }
        })
      })
    }
  }

  importar (event) {
    this.alertas = []
    this.data = null
    this.error = null

    if (!event || !event.headers || !event.data) return

    if (event.headers.indexOf('colaborador') < 0 && event.headers.indexOf('colaborador_id') < 0) {
      return this.error = 'Especifique la columna "Colaborador" o "Colaborador ID"'
    }

    this.data = event.data
  }

  validar () {
    this.alertas = []
    if (this.step === 2) return

    this.step = 2
  }

  verificar (colaborador) {
    this.ColaboradorService.get(this.idProyecto, colaborador.colaborador_id)
      .then(({data}) => {
        let respuesta = data
        this.eliminable = !(respuesta.requeridos.creditos !== 0 || respuesta.requeridos.nominas !== 0 || respuesta.requeridos.incapacidades !== 0 || respuesta.requeridos.movimientos !== 0)

        colaborador.eliminable = this.eliminable

        if (this.eliminable) return colaborador
        let mensaje = ''
        if (respuesta.requeridos.creditos !== 0) {
          mensaje = 'Se encontraron ' + respuesta.requeridos.creditos + ' creditos'
        } else if (respuesta.requeridos.nominas !== 0) {
          mensaje = 'Se encontraron ' + respuesta.requeridos.nominas + ' nóminas'
        } else if (respuesta.requeridos.incapacidades !== 0) {
          mensaje = 'Se encontraron ' + respuesta.requeridos.incapacidades + ' incapacidades'
        } else if (respuesta.requeridos.movimientos !== 0) {
          mensaje = 'Se encontraron ' + respuesta.requeridos.movimientos + ' movimientos'
        }

        colaborador.mensaje = mensaje
      })
      .catch(({error}) => {
        colaborador.error = error
      })
      .finally(() => {
        this.colaboradores.push(colaborador)
        this.filtradoColaboradores()
      })
  }
}

module.component('fanProyectoColaboradoresEditarEliminar', {
  controller: FanProyectoColaboradoresEditarEliminarComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/eliminar/component.js